<div
  class="relative p-[10px] border-2 border-solid border-transparent transition-border duration-300 ease-in-out hover:!border-2 hover:!border-solid hover:!border-primary w-[100%] cursor-pointer"
  [id]="'pagemodule' + content.id"
  [ngStyle]="{
    backgroundColor: styles.colors['other']['background'],
  }"
  [ngClass]="{
    '!border-2 !border-solid !border-primary': isSelectedModule,
  }">
  <div class="text-center">
    @if (logoItem?.value?.url) {
      <img
        [src]="logoItem.value.url"
        [alt]="logoItem?.value?.altText"
        class="w-[100%] h-[100px] object-contain" />
    }
  </div>
  <div class="text-center relative">
    @if (headerImageItem?.value?.url) {
      <img
        [src]="headerImageItem.value.url"
        class="w-[100%] object-cover" />
    }
  </div>
  @if (headlineItem?.value?.text) {
    <div class="text-center mt-5">
      <div
        class="break-words"
        [attr.style]="buildStyle('text', headlineItem?.styles?.text)"
      >
        {{ headlineItem.value.text }}
      </div>
    </div>
  }
  @if (descriptionItem?.value?.text) {
    <div class="text-justify break-words">
      <div
        [attr.style]="buildStyle('text', descriptionItem?.styles?.text)"
        [innerHTML]="descriptionItem.value.text | lineBreak"
      ></div>
    </div>
  }
  @if (titleItem?.value?.text) {
    <div class="text-center break-words mt-5">
      <div
        class="break-words"
        [attr.style]="buildStyle('text', titleItem?.styles?.text)"
      >
        {{ titleItem.value.text }}
      </div>
    </div>
  }
  @if (paragraphItem?.value?.text) {
    <div class="text-justify">
      <div
        class="break-words"
        [innerHTML]="paragraphItem.value.text | lineBreak"
        [attr.style]="buildStyle('text', paragraphItem?.styles?.text)"
      ></div>
    </div>
  }
</div>
